namespace TabAurous.Stock {
    export namespace JewelleryShapeandVoucherService {
        export const baseUrl = 'Stock/JewelleryShapeandVoucherWise';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/JewelleryShapeandVoucherWise/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>JewelleryShapeandVoucherService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
